
<template lang="html">
  <section class="wrapper wrapper-view">

    <nav class="breadcrumb container">
      <router-link to="/">Home</router-link>
      <router-link :to="$t('enlaces.ofertas')">Ofertas</router-link>
      <router-link :to="$route.fullPath" v-if="!!data">{{data.titulo}}</router-link>
    </nav>

    <div class="ficha-oferta container" v-if="!!data">

      <div class="top row-between">

        <a @click="$router.go(-1)" class="volver">Volver</a>

        <button class="btn -cyan" v-if="data.permiteInscripcion &
          !!!data.estadoInscripcion" @click="requestInscripcion"
          :loading="loading">Inscribirme</button>
      </div>


      <div class="oferta-el row-start">

        <div class="contenedor-texto">
          <div class="top column-start">
            <h3 class="empresa">{{data.empresa}}</h3>
            <h3 class="estado" v-if="!!data.estadoInscripcion"
              :data="data.estadoInscripcion">{{data.estadoInscripcion}}</h3>
          </div>
          <div class="middle row-between">
            <h2 class="titulo">{{data.titulo}}</h2>
            <h3 class="estudios row-start"
              v-if="!!data.titulaciones_Requeridas">
              <strong>Estudios: </strong>
              <a v-if="data.titulaciones_Requeridas.length> 1"
                class="showtitulaciones" @click="showpopup = true" >Ver
                titulaciones</a>
              <span v-else> {{data.titulaciones_Requeridas[0]}}</span>
            </h3>
          </div>
        </div>
        <div class="tips column-start">
          <h3 v-if="!!data.fecha" class="fecha">{{data.fecha}}</h3>
          <h3 class="localizacion" v-if="!!data.provincia || data.localidad">
            {{data.provincia}}
            <template v-if="!!!data.provincia & !!data.localidad">
              {{data.localidad}}
            </template>
          </h3>
        </div>
      </div>

      <div class="descripcion" v-if="data.descripcion.includes('<p>')"
        v-html="data.descripcion"></div>
      <div class="descripcion" v-else>
        <p v-html="data.descripcion"></p>
      </div>

      <div class="contenedor-imagen" v-if="!!data.imgPrincipal">
        <img :src="data.imgPrincipal" :alt="data.titulo">
      </div>

      <div class="datos row-start">
        <p v-if="!!data.empresa" class="dato"><strong>Empresa:</strong>
          {{data.empresa}}</p>
        <p class="dato" v-if="!!data.plazas"><strong>Cantidad de puestos disponibles:</strong>
          {{data.plazas}}</p>
        <p v-if="!!data.departamento" class="dato"><strong>Departamento:</strong>
          {{data.departamento}}</p>
        <p class="dato" v-if="!!data.sectorEmpresaDestino"><strong>Sector actividad
            empresa destino:</strong> {{data.sectorEmpresaDestino}}</p>
        <p class="dato" v-if="!!data.direccion"><strong>Dirección:</strong>
          <template v-if="!!data.direccion">{{data.direccion}}</template><template v-if="!!data.localidad">, {{data.localidad}}</template><template v-if="!!data.provincia">, {{data.provincia}}</template><template v-if="!!data.pais">, {{data.pais}}</template>
        </p>

        <p class="dato" v-if="!!data.curricular">
          <strong>Tipo de práctica:</strong>
          Práctica curricular
        </p>

        <p class="dato" v-if="!!data.sectorEmpresa"><strong>Sector empresa:</strong>
          {{data.sectorEmpresa}}</p>
        <p class="dato" v-if="!!data.fechaInicio"><strong>Fecha de inicio
            prevista:</strong> {{data.fechaInicio}}</p>
        <p class="dato" v-if="!!data.horario"><strong>Horario de trabajo:</strong>
          {{data.horario}}</p>
        <p class="dato" v-if="!!data.duracionPrevista"><strong>Duración
            prevista:</strong> {{data.duracionPrevista}}</p>

        <p class="dato" v-if="!!data.remuneracion | !!data.ayudaAlEstudio"><strong>Remuneración{{(data.idperfil
            == 1) ? ' práctica' : null}}:</strong> {{(!!data.remuneracion) ?
          data.remuneracion : data.ayudaAlEstudio}}</p>

        <p class="dato" v-if="!!data.otrasRemuneraciones">
          <strong>Otras remuneraciones:</strong>
          {{data.otrasRemuneraciones}}
        </p>

        <p class="dato" v-if="!!data.otrosIncentivos">
          <strong>Otras incentivos:</strong>
          {{data.otrosIncentivos}}
        </p>

        <p class="dato" v-if="!!data.contrato">
          <strong>Tipo de contrato:</strong>
          {{data.contrato}}
        </p>

        <p class="dato" v-if="!!data.fechaTope">
          <strong>Fecha Tope:</strong>
          <span v-html="data.fechaTope"></span>
        </p>

      </div>


      <template v-if=!!data.documentacionAdjunta>

      <h3 class="subtitle-section mt" v-if="data.documentacionAdjunta.length !=
        0">Documentación de interés</h3>


      <div class="docs column-start" v-if="data.documentacionAdjunta.length> 0">
        <a target="_blank" :href="doc.enlace" class="link" v-for="doc in
          data.documentacionAdjunta">{{doc.nombre}}</a>
      </div>

    </template>

      <template v-if="!!data.documentos">
      <h2 class="title-section" v-if="data.documentos.length != 0">Documentación</h2>
      <p v-if="data.documentos.length != 0"><strong>Documentación requerida</strong></p>
      <ul class="circle-list" v-if="data.documentos.length != 0">
        <li v-for="doc in data.documentos">{{doc.nombre}}</li>
      </ul>
    </template>


    <template v-if="!!data.idiomas_deseables ||
    !!data.idiomas_requeridos">

      <h2 class="title-section" v-if="!!data.idiomas_deseables ||
        !!data.idiomas_requeridos">Idiomas</h2>

      <p v-if="!!data.idiomas_requeridos"><strong>Idiomas requeridos</strong></p>
      <ul class="circle-list" v-if="!!data.idiomas_requeridos">
        <li v-for="idioma in data.idiomas_requeridos">{{idioma.idioma}} -
          {{idioma.nivel}} <template v-if="!!idioma.descripcionCertificacion">-</template>
          {{idioma.descripcionCertificacion}}</li>
      </ul>

      <p v-if="!!data.idiomas_deseables"><strong>Idiomas deseables</strong></p>
      <ul class="circle-list" v-if="!!data.idiomas_deseables">
        <li v-for="idioma in data.idiomas_deseables">{{idioma.idioma}} <template
            v-if="!!idioma.nivel">-</template> {{idioma.nivel}} <template
            v-if="!!idioma.descripcionCertificacion">-</template>
          {{idioma.descripcionCertificacion}}</li>
      </ul>

    </template>

      <h2 class="title-section" v-if="$route.name == 'ficha-oferta'">Requisitos del puesto</h2>

 

      <p class="dato" v-if="!!data.titulaciones_Requeridas"><strong>Estudios
          obligatorios:</strong>
        <a v-if="data.titulaciones_Requeridas.length> 1"
          class="showtitulaciones" @click="showpopup = true" >Ver
          titulaciones</a>
        <span v-else> {{data.titulaciones_Requeridas[0]}}</span>
      </p>
      

      <p class="dato" v-if="!!data.requisitos_obligatorios">
        <strong>Requisitos obligatorios:</strong>
        <span v-html="data.requisitos_obligatorios"></span>
      </p>

      <p class="dato" v-if="!!data.requisitos">
        <strong>Requisitos:</strong>
        <span v-html="data.requisitos"></span>
      </p>

      <p class="dato" v-if="!!data.titulaciones"><strong>Estudios
        obligatorios:</strong>
      <a v-if="data.titulaciones.length> 1"
        class="showtitulaciones" @click="showpopup = true" >Ver
        titulaciones</a>
      <span v-else> {{data.titulaciones[0]}}</span>
    </p>
  

      <a v-if="!!data.linkMasInfo" :href="data.linkMasInfo" target="_blank" class="link">{{(!!data.masInfo) ? data.masInfo : 'más información'}}</a>


      <p class="dato" v-if="!!data.requisitos_deseables">
        <strong>Requisitos deseables:</strong>
        <span v-html="data.requisitos_deseables"></span>
      </p>

      <p class="dato" v-if="!!data.experiencia">
        <strong>Experiencia:</strong>
        <span v-html="data.experiencia"></span>
      </p>

      <p class="dato" v-if="!!data.otrosEstudiosObligatorios">
        <strong>Otra formación:</strong>
        <span v-html="data.otrosEstudiosObligatorios"></span>
      </p>

      <p class="dato" v-if="!!data.requisitos_otros">
        <strong>Otra requisitos:</strong>
        <span v-html="data.requisitos_otros"></span>
      </p>

      <p class="dato" v-if="!!data.programasInformaticos">
        <strong>Programas informáticos:</strong>
        <span v-html="data.programasInformaticos">data.programasInformaticos</span>
      </p>
      <div class="contenedor-boton">
        <button :loading="loading" class="btn -cyan"
          v-if="data.permiteInscripcion & !!!data.estadoInscripcion"
          @click="requestInscripcion">Inscribirme</button>
      </div>

    </div>

    <div class="view-loading" v-else></div>

    <div class="cover-popup row-center" v-if="showpopup">
      <span class="close-cover" @click="showpopup= false"></span>
      <div class="popup -estudios">
        <a class="close" @click="showpopup= false">✕</a>
        <h2 class="title-pop" v-if="!!titulacionesOrder">Listado de estudios requeridos</h2>
        <ul class="row-start">
          <li v-for="(tit,key) in titulacionesOrder">
            {{tit}}
          </li>
        </ul>
        <h2 v-if="!!data.titulacioness_deseables" class="title-pop">Listado de estudios deseables</h2>
        <ul class="row-start" v-if="!!data.titulacioness_deseables">
          <li v-for="(tit,key) in titulacioness_deseables">
            {{tit}}
          </li>
        </ul>
      </div>
    </div>


    <div class="cover-popup row-center" v-if="showpopupinscripcion">
      <span class="close-cover" @click="showpopupinscripcion= false"></span>
      <div class="popup">
        <a class="close" @click="showpopupinscripcion= false">✕</a>
        <h2 class="title-pop">¡Atención!</h2>
        <p>
          ¿Estás seguro? Solamente puedes inscribirte a 3 ofertas internas UFV
        </p>
        <div class="contenedor-botones row-center">
          <button class="btn" @click="sendInscripcion" :loading="loading">Continuar</button>
          <button class="btn -skull" @click="showpopupinscripcion= false">Cancelar</button>
        </div>
      </div>
    </div>


    <div class="cover-popup row-center" v-if="showpopupdocumentos">
      <span class="close-cover" @click="showpopupdocumentos= false"></span>
      <div class="popup">
        <a class="close" @click="showpopupdocumentos= false">✕</a>
        <h2 class="title-pop">¡Atención!</h2>
        <p>
          Para terminar la inscripción, necesitamos que adjuntes la siguiente
          documentación requerida:
        </p>
        <p><strong>{{documentacion[docActive].nombre}} <template v-if="documentacion.length > 1">({{docActive+1}} /
            {{documentacion.length}})</template></strong></p>
        <dropzone @emit="setDoc" ref="dropzone" :key="key" v-if="docActive ==
          key"
          v-for="(doc,key) in documentacion"></dropzone>
        <div class="contenedor-botones row-center">
          <button class="btn" v-if="!!docComplete" @click="sendInscripcion"
            :loading="loading">Continuar</button>
          <button class="btn" v-else @click="nextDoc">Continuar</button>
          <button class="btn -skull" @click="showpopupdocumentos= false">Cancelar</button>
        </div>
      </div>
    </div>

    <div class="cover-popup row-center" v-if="!!mensajeerror">
      <span class="close-cover"></span>
      <div class="popup">
        <h2 class="title-pop">¡Atención!</h2>
        <p v-html="mensajeerror"></p>
        <button @click="mensajeerror = ''" class="btn">Aceptar</button>
      </div>
    </div>


  </section>

</template>

<script lang="js">

  import {mapActions, mapGetters} from 'vuex';

  import dropzone from '@/components/parts/dropzone';

  export default {
    name: 'ficha-oferta',
    mounted(){
      if(this.logged){
        this.getOferta();
      }
    },
    data(){
      return{
        showpopup : false,
        showpopupinscripcion : false,
        showpopupdocumentos : false,
        data : '',
        loading: false,
        documentacion : [],
        docActive : 0,
        mensajeerror : ''
      }
    },
    methods: {
      ...mapActions(['requestOferta','inscribirmeOferta','requestProgramaIndependiente']),
      getOferta(){
        setTimeout(e => {

            if(this.$route.name == 'ficha-oferta'){

            this.requestOferta(this.$route.params.id).then( r =>{
              this.data = r;
              document.title = this.data.titulo
            });

            }else{

              
              this.requestProgramaIndependiente(this.$route.params.id).then( r =>{
                this.data = r;
                document.title = this.data.titulo
              });
              
              
            }

        },100)
      },
      requestInscripcion(){
        if(!!this.isEstudiante & this.data.esInterna){
          this.showpopupinscripcion = true;
        }else{
          this.sendInscripcion();
        }
      },
      sendInscripcion(){

        let data = {
          "urlOferta": this.$route.params.id,
          "documentacion": this.documentacion
        };

        this.loading = true;

        this.inscribirmeOferta(data).then(r => {          
          if(r == true){
            this.documentacion = [];
            this.showpopupdocumentos = false;
            this.showpopupinscripcion = false;
            this.docActive = 0;
            this.getOferta();
          }else{
            r.forEach(e => {
              let doc = {
                "id": '',
                "fecha": "",
                "tipo": e.idTipo,
                "enlace": "",
                "nombre": e.nombre,
                "ficheroB64ParaAltas": "",
                "extension_adjunto": "",
                "idDocumentoNecesarioOfertaNoTipado": e.idDocumentoNecesario
              }

              this.documentacion.push(doc);
              this.showpopupdocumentos = true;
            });
          }
          this.loading = false;
        }).catch(e =>{
          this.loading = false;
          this.showpopupinscripcion = false;
          this.mensajeerror = e;
        })
      },
      setDoc(value) {
        this.documentacion[this.docActive].extension_adjunto = value.extension_adjunto;
        this.documentacion[this.docActive].ficheroB64ParaAltas = value.ficheroB64ParaAltas;
        this.documentacion[this.docActive].fecha = value.fecha;
      },
      nextDoc(){
        if(!!this.documentacion[this.docActive].extension_adjunto){
          this.docActive++;
        }
      }
    },
    computed : {
      ...mapGetters({
        logged : 'getLogged',
        isEstudiante : 'isEstudiante'
      }),
      docComplete(){
        let length;
        if(!!this.documentacion){
          length = this.documentacion.filter(e => !!e.ficheroB64ParaAltas).length;
        }
        return (length == this.documentacion.length);
      },
      titulacionesOrder(){
          let titulaciones;
          
          if(!!this.data.titulaciones_Requeridas){

            if(this.data.titulaciones_Requeridas.length != 0){
              titulaciones = this.data.titulaciones_Requeridas.sort(function (p1, p2) {
                return (p1.toLowerCase() < p2.toLowerCase()) ? -1 : 1;
              });
            }
            
          }


          if(!!this.data.titulaciones){
            if(this.data.titulaciones.length != 0){
              titulaciones = this.data.titulaciones.sort(function (p1, p2) {
                return (p1.toLowerCase() < p2.toLowerCase()) ? -1 : 1;
              });
            }
          }
          return titulaciones;
      }
    },
    components : {
            'dropzone': dropzone,
        }
  }
</script>

<style scoped lang="scss">
  .dato span {
    border-left:none;
    padding-left: 0px;
    margin-left: 0px;
}

.estado{
  margin-top: 5px;
}

</style>


// WEBPACK FOOTER //
// src/components/views/ficha-oferta.vue